import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import ContentImageBlock from './ContentImageBlock';
import FeaturesFlipScroller from './FeaturesFlipScroller';
import Hero from '../Hero/ImageWithJumper';
import ShopPosterFooter from './ShopPosterFooter';
import UgcGridCarousel from './UgcGridCarousel';
import ToggleProductCategories from './ToggleProductCategories';
import css from './ProductSpotlightSimple.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ProductSpotlightSimple = function ProductSpotlightSimple(_ref) {
  var fabric = _ref.fabric,
      fabricProductCategories = _ref.fabricProductCategories,
      features = _ref.features,
      footerHero = _ref.footerHero,
      hero = _ref.hero,
      productItemsMen = _ref.productItemsMen,
      productItemsWomen = _ref.productItemsWomen,
      productItemsTitle = _ref.productItemsTitle,
      subHero = _ref.subHero,
      ugcs = _ref.ugcs,
      ugcsTitle = _ref.ugcsTitle;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx(Hero, _objectSpread({}, hero)), /*#__PURE__*/_jsx(ContentImageBlock, _objectSpread(_objectSpread({}, subHero), {}, {
      subHero: true,
      imageRight: true
    })), /*#__PURE__*/_jsx(FeaturesFlipScroller, {
      features: features
    }), /*#__PURE__*/_jsx(ToggleProductCategories, {
      productItemsMen: productItemsMen,
      productItemsWomen: productItemsWomen,
      fabric: fabricProductCategories || fabric,
      title: productItemsTitle
    }), /*#__PURE__*/_jsx(UgcGridCarousel, {
      fabric: fabric,
      ugcs: ugcs,
      ugcsTitle: ugcsTitle
    }), /*#__PURE__*/_jsx(ShopPosterFooter, _objectSpread(_objectSpread({}, footerHero), {}, {
      fabric: fabric
    }))]
  });
};

var ctaProps = PropTypes.shape({
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
}).isRequired;
var imageProps = PropTypes.shape({
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired
}).isRequired;
var productItemPropTypes = {
  cta: PropTypes.string.isRequired,
  fabric: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
  image: PropTypes.string.isRequired,
  imageLeft: PropTypes.bool,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};
ProductSpotlightSimple.default = {
  fabricProductCategories: false
};
ProductSpotlightSimple.propTypes = {
  fabric: PropTypes.string.isRequired,
  fabricProductCategories: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  features: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string,
    quote: PropTypes.string,
    quoter: PropTypes.string,
    id: PropTypes.string.isRequired,
    image: imageProps,
    title: PropTypes.string
  })).isRequired,
  footerHero: PropTypes.shape({
    cta: ctaProps,
    image: imageProps,
    imageMobile: imageProps,
    messages: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
  }).isRequired,
  hero: PropTypes.shape({
    cta: ctaProps,
    title: PropTypes.string.isRequired
  }).isRequired,
  subHero: PropTypes.shape({
    cta: ctaProps,
    description: PropTypes.string.isRequired,
    image: imageProps,
    imageMobile: imageProps,
    title: PropTypes.string.isRequired
  }).isRequired,
  productItemsMen: PropTypes.arrayOf(PropTypes.shape(_objectSpread({}, productItemPropTypes))).isRequired,
  productItemsWomen: PropTypes.arrayOf(PropTypes.shape(_objectSpread({}, productItemPropTypes))).isRequired,
  productItemsTitle: PropTypes.string.isRequired,
  ugcs: PropTypes.arrayOf(PropTypes.shape({
    hoverText: PropTypes.string.isRequired,
    image: imageProps
  })).isRequired,
  ugcsTitle: PropTypes.string.isRequired
};
export default ProductSpotlightSimple;